import { selectBasketItem, selectBasketToPay, updateBasketItem } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import useTranslation from 'hooks/useTranslation'
import Select from 'components/inputs/Select'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import React from 'react'

interface PeriodToPay {
  value: string
  name: string
  grossPriceBeforeDiscount?: string
  hashes: string[]
  discount?: string
  grossPrice: number
  netPrice: number
}

const PeriodsToPay: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const toPay = useReduxSelector(selectBasketToPay)
  const { periodsToPay, identifier } = useSelector(state => selectBasketItem(state, id))

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('basket')

  const periods_to_pay = (toPay?.[identifier]?.periods_to_pay || []) as PeriodToPay[]

  return (
    <div className='periodsToPay'>
      <div className='title'>
        <div>
          <span>{t('paymentForThePeriod')}</span>
        </div>
      </div>

      <div className='orderInfo__periodsToPay'>
        <Select
          options={periods_to_pay}
          disabled={!periods_to_pay}
          value={periods_to_pay?.[periodsToPay]?.value}
          label={t('whatPeriodDoYouWantToPayForInAdvance')}
          setValue={value => {
            const index = periods_to_pay.findIndex(p => p.value === value)
            dispatch(updateBasketItem({ identifier: id, values: { periodsToPay: index } }))
          }}
        />
      </div>
    </div>
  )
}

export default PeriodsToPay